import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import ContactForm from '../components/ContactForm'; // We'll just reuse the ContactForm component as the main body here

function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="container" style={{ paddingTop: '80px', paddingBottom: '80px' }}>
        <button 
          className="btn btn-outline" 
          onClick={() => window.location.hash = ''}
          style={{ marginBottom: '40px' }}
        >
          ← Torna alla home
        </button>

        <h1 className="section-title" style={{ textAlign: 'left', marginBottom: '16px' }}>Contattaci</h1>
        <p className="section-subtitle" style={{ textAlign: 'left', margin: '0 0 48px 0', maxWidth: '100%' }}>
          Hai dubbi su un'adozione o vuoi semplicemente avere maggiori informazioni? 
          Siamo sempre felici di fare quattro chiacchiere. Scrivici o vieni a trovarci!
        </p>
      </div>

      {/* We reuse the footer component which has the form, but without the top radiuses if we wanted, 
          although reusing it exactly is fine for a unified look. */}
      <div style={{ marginTop: 'auto' }}>
        <ContactForm />
      </div>
    </>
  );
}

export default ContactPage;
